"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.whiteShadedArray = void 0;
exports.whiteShadedArray = [
    "white",
    "header-white",
    "theme-background",
    "mecha-white",
    "mecha-yellow",
    "storm-dust",
    "input-background",
    "input-border",
    "login-input-background",
    "textbox-default-background",
    "search-bar",
];
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29uc3RhbnRzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvY29uc3RhbnRzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFhLFFBQUEsZ0JBQWdCLEdBQUc7SUFDOUIsT0FBTztJQUNQLGNBQWM7SUFDZCxrQkFBa0I7SUFDbEIsYUFBYTtJQUNiLGNBQWM7SUFDZCxZQUFZO0lBQ1osa0JBQWtCO0lBQ2xCLGNBQWM7SUFDZCx3QkFBd0I7SUFDeEIsNEJBQTRCO0lBQzVCLFlBQVk7Q0FDYixDQUFDIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGNvbnN0IHdoaXRlU2hhZGVkQXJyYXkgPSBbXG4gIFwid2hpdGVcIixcbiAgXCJoZWFkZXItd2hpdGVcIixcbiAgXCJ0aGVtZS1iYWNrZ3JvdW5kXCIsXG4gIFwibWVjaGEtd2hpdGVcIixcbiAgXCJtZWNoYS15ZWxsb3dcIixcbiAgXCJzdG9ybS1kdXN0XCIsXG4gIFwiaW5wdXQtYmFja2dyb3VuZFwiLFxuICBcImlucHV0LWJvcmRlclwiLFxuICBcImxvZ2luLWlucHV0LWJhY2tncm91bmRcIixcbiAgXCJ0ZXh0Ym94LWRlZmF1bHQtYmFja2dyb3VuZFwiLFxuICBcInNlYXJjaC1iYXJcIixcbl07XG4iXX0=